import { PMPM_STATUSES } from './common'


export enum coachTires {
	tier1Coach = 'tier1Coach',
	tier2Coach = 'tier2Coach',
	tier3Coach = 'tier3Coach',
}

export interface CoachSystemData {
	[key: string]: any
	_id: string
	imageUrl?: string | null
	firstName: string
	lastName: string
	contact?: CoachSystemDataContact
	contactShipping?: CoachSystemDataContact
	startOfService?: string
	personal?: CoachSystemDataPersonal
	availability?: CoachSystemAvailability
	availabilityDays?: CoachSystemAvailabilityDays
	account: string | null
	engagementData?: CoachSystemDataEngagementData
	[coachTires.tier1Coach]: CoachSystemDataTierCoach
	[coachTires.tier2Coach]: CoachSystemDataTierCoach
	[coachTires.tier3Coach]: CoachSystemDataTierCoach
	email?: string
	ID: string
	attentions?: string
	diabetesProfile?: CoachSystemDataDiabetesProfile
	phone?: string
	pmpm?: CoachSystemDataPMPM
}

export enum COACH_SYSTEM_DATA_ACTION_TYPES {
	COACH_SYSTEM_SET_DATA = 'COACH_SYSTEM_SET_DATA',
}

export enum COACH_SYSTEM_DATA_UNSCHEDULED_CALLS_VALUES {
	APPROVED = 'Approved',
	DISAPPROVED = 'Disapproved',
}

export enum ENGAGEMENT_STATUS {
	ENGAGED = 'Engaged',
	DISENGAGED = 'Disengaged',
	NEWLY = 'Newly and rolled',
	OUTREACH = 'Outreach',
}

export enum PATIENT_PLANS {
	MSK = 'MSK',
}

export interface CoachSystemDataPMPM {
	active?: boolean
	cancelDate?: string
	status?: PMPM_STATUSES
}

export type EngagementStatus =
	| Lowercase<keyof typeof ENGAGEMENT_STATUS>
	| undefined

export interface CoachSystemDataContact {
	country?: string
	zipCode?: string
	addressLine1?: string
	addressLine2?: string
	city?: string
	state?: string
	alternativePhone?: string
}

export interface CoachSystemDataTierCoach {
	roleTypes?: Array<string>
	_id?: string
	coachId?: string
	name?: string
	imageUrl?: string
}

export interface CoachSystemDataDiabetesProfile {
	bmi?: string
}

export interface CoachSystemDataEngagementData {
	plan?: Array<string>
	memberSince?: string
	coachingMinutes?: number
	billableActivity?: string
	lastActiveContect?: string
	measurements?: number
	engagementStatus?: EngagementStatus
}

export interface CoachSystemDataPersonal {
	employment?: string
	job?: string
	title?: 'string'
	maritalStatus?: string
	smoking?: string
}

export interface CoachSystemAvailabilityDays {
	[key: string]: any
	Monday?: boolean
	Tuesday?: boolean
	Wednesday?: boolean
	Thursday?: boolean
	Friday?: boolean
	Saturday?: boolean
	Sunday?: boolean
}

export interface CoachSystemAvailability {
	[key: string]: any
	afternoon?: boolean
	evening?: boolean
	morning?: boolean
	noon?: boolean
	days?: Array<string>
	methods?: Array<string>
	unscheduled?: boolean
}

interface CoachSystemSetDataAction {
	type: COACH_SYSTEM_DATA_ACTION_TYPES.COACH_SYSTEM_SET_DATA
	payload: CoachSystemData
}

export type CoachSystemActions = CoachSystemSetDataAction
